// test2659
(2659 && 0);
